export const personTypesData = [
  {
    type: "ESTJ",
    funcsStack: [
      { cogFunc: "thinking", isExvert: true, stackFunc: "dominant" },
      { cogFunc: "sensing", isExvert: false, stackFunc: "auxiliary" },
      { cogFunc: "intuition", isExvert: true, stackFunc: "tertiary" },
      { cogFunc: "feeling", isExvert: false, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.35,
      ns: 0.75,
      tf: 0.15,
    },
    profile: {
      description:
        "Practical, realistic and decisive when implementing decisions.",
    },
  },
  {
    type: "ESFJ",
    funcsStack: [
      { cogFunc: "feeling", isExvert: true, stackFunc: "dominant" },
      { cogFunc: "sensing", isExvert: false, stackFunc: "auxiliary" },
      { cogFunc: "intuition", isExvert: true, stackFunc: "tertiary" },
      { cogFunc: "thinking", isExvert: false, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.25,
      ns: 0.75,
      tf: 0.85,
    },
    profile: {
      description:
        "Warmhearted, cooperative and who is determined to establish harmony in their environment.",
    },
  },
  {
    type: "ESTP",
    funcsStack: [
      { cogFunc: "sensing", isExvert: true, stackFunc: "dominant" },
      { cogFunc: "thinking", isExvert: false, stackFunc: "auxiliary" },
      { cogFunc: "feeling", isExvert: true, stackFunc: "tertiary" },
      { cogFunc: "intuition", isExvert: false, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.25,
      ns: 0.85,
      tf: 0.35,
    },
    profile: {
      description:
        "Flexible and tolerant who takes a pragmatic approach to get immediate results.",
    },
  },
  {
    type: "ESFP",
    funcsStack: [
      { cogFunc: "sensing", isExvert: true, stackFunc: "dominant" },
      { cogFunc: "feeling", isExvert: false, stackFunc: "auxiliary" },
      { cogFunc: "thinking", isExvert: true, stackFunc: "tertiary" },
      { cogFunc: "intuition", isExvert: false, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.25,
      ns: 0.75,
      tf: 0.65,
    },
    profile: {
      description:
        "Outgoing, friendly, and loves material comforts, people and life.",
    },
  },
  {
    type: "ENTJ",
    funcsStack: [
      { cogFunc: "thinking", isExvert: true, stackFunc: "dominant" },
      { cogFunc: "intuition", isExvert: false, stackFunc: "auxiliary" },
      { cogFunc: "sensing", isExvert: true, stackFunc: "tertiary" },
      { cogFunc: "feeling", isExvert: false, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.25,
      ns: 0.25,
      tf: 0.15,
    },
    profile: {
      description:
        "Decisive, frank, assume leadership by default and who implements comprehensive systems to solve issues.",
    },
  },
  {
    type: "ENFJ",
    funcsStack: [
      { cogFunc: "feeling", isExvert: true, stackFunc: "dominant" },
      { cogFunc: "intuition", isExvert: false, stackFunc: "auxiliary" },
      { cogFunc: "sensing", isExvert: true, stackFunc: "tertiary" },
      { cogFunc: "thinking", isExvert: false, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.25,
      ns: 0.25,
      tf: 0.85,
    },
    profile: {
      description:
        "Empathetic, responsible and highly attuned to the emotions and motivations of others.",
    },
  },
  {
    type: "ENTP",
    funcsStack: [
      { cogFunc: "intuition", isExvert: true, stackFunc: "dominant" },
      { cogFunc: "thinking", isExvert: false, stackFunc: "auxiliary" },
      { cogFunc: "feeling", isExvert: true, stackFunc: "tertiary" },
      { cogFunc: "sensing", isExvert: false, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.25,
      ns: 0.15,
      tf: 0.25,
    },
    profile: {
      description:
        "Quick, ingenious, outspoken and resourceful in solving new and challenging problems.",
    },
  },
  {
    type: "ENFP",
    funcsStack: [
      { cogFunc: "intuition", isExvert: true, stackFunc: "dominant" },
      { cogFunc: "feeling", isExvert: false, stackFunc: "auxiliary" },
      { cogFunc: "thinking", isExvert: true, stackFunc: "tertiary" },
      { cogFunc: "sensing", isExvert: false, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.25,
      ns: 0.15,
      tf: 0.75,
    },
    profile: {
      description:
        "Warmly enthusiastic, imaginative and see life as full of possibilities.",
    },
  },
  {
    type: "ISTJ",
    funcsStack: [
      { cogFunc: "sensing", isExvert: false, stackFunc: "dominant" },
      { cogFunc: "thinking", isExvert: true, stackFunc: "auxiliary" },
      { cogFunc: "feeling", isExvert: false, stackFunc: "tertiary" },
      { cogFunc: "intuition", isExvert: true, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.75,
      ns: 0.85,
      tf: 0.25,
    },
    profile: {
      description:
        "Serious, quiet, practical, and responsible who people can rely on.",
    },
  },
  {
    type: "ISFJ",
    funcsStack: [
      { cogFunc: "sensing", isExvert: false, stackFunc: "dominant" },
      { cogFunc: "feeling", isExvert: true, stackFunc: "auxiliary" },
      { cogFunc: "thinking", isExvert: false, stackFunc: "tertiary" },
      { cogFunc: "intuition", isExvert: true, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.75,
      ns: 0.85,
      tf: 0.75,
    },
    profile: {
      description:
        "Quiet, friendly, responsible and committed and consistent in their duties and obligations.",
    },
  },
  {
    type: "ISTP",
    funcsStack: [
      { cogFunc: "thinking", isExvert: false, stackFunc: "dominant" },
      { cogFunc: "sensing", isExvert: true, stackFunc: "auxiliary" },
      { cogFunc: "intuition", isExvert: false, stackFunc: "tertiary" },
      { cogFunc: "feeling", isExvert: true, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.75,
      ns: 0.75,
      tf: 0.15,
    },
    profile: {
      description:
        "Quiet, flexible and tolerant observers, who can act quickly to find workable solutions.",
    },
  },
  {
    type: "ISFP",
    funcsStack: [
      { cogFunc: "feeling", isExvert: false, stackFunc: "dominant" },
      { cogFunc: "sensing", isExvert: true, stackFunc: "auxiliary" },
      { cogFunc: "intuition", isExvert: false, stackFunc: "tertiary" },
      { cogFunc: "thinking", isExvert: true, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.75,
      ns: 0.75,
      tf: 0.85,
    },
    profile: {
      description:
        "Quiet, sensitive, and kind who enjoys the present perfect moments and the current events.",
    },
  },
  {
    type: "INTJ",
    funcsStack: [
      { cogFunc: "intuition", isExvert: false, stackFunc: "dominant" },
      { cogFunc: "thinking", isExvert: true, stackFunc: "auxiliary" },
      { cogFunc: "feeling", isExvert: false, stackFunc: "tertiary" },
      { cogFunc: "sensing", isExvert: true, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.75,
      ns: 0.15,
      tf: 0.25,
    },
    profile: {
      description:
        "Have original minds and self-driven in executing their ideas and achieving their objectives.",
    },
  },
  {
    type: "INFJ",
    funcsStack: [
      { cogFunc: "intuition", isExvert: false, stackFunc: "dominant" },
      { cogFunc: "feeling", isExvert: true, stackFunc: "auxiliary" },
      { cogFunc: "thinking", isExvert: false, stackFunc: "tertiary" },
      { cogFunc: "sensing", isExvert: true, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.75,
      ns: 0.15,
      tf: 0.75,
    },
    profile: {
      description:
        "Seeking for meaning and connection between ideas and relationships and who is also insightful with other peoples' motivations.",
    },
  },
  {
    type: "INTP",
    funcsStack: [
      { cogFunc: "thinking", isExvert: false, stackFunc: "dominant" },
      { cogFunc: "intuition", isExvert: true, stackFunc: "auxiliary" },
      { cogFunc: "sensing", isExvert: false, stackFunc: "tertiary" },
      { cogFunc: "feeling", isExvert: true, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.75,
      ns: 0.25,
      tf: 0.15,
    },
    profile: {
      description:
        "Theoretical, abstract-minded and seek to arrive to logical explanations for everything that is interesting. ",
    },
  },
  {
    type: "INFP",
    funcsStack: [
      { cogFunc: "feeling", isExvert: false, stackFunc: "dominant" },
      { cogFunc: "intuition", isExvert: true, stackFunc: "auxiliary" },
      { cogFunc: "sensing", isExvert: false, stackFunc: "tertiary" },
      { cogFunc: "thinking", isExvert: true, stackFunc: "inferior" },
    ],
    params: {
      xvn: 0.75,
      ns: 0.25,
      tf: 0.85,
    },
    profile: {
      description:
        "Idealistic and loyal to the people and whose external life is aligned to the cherished value-system.",
    },
  },
];
